import { render, staticRenderFns } from "./EditUserModal.vue?vue&type=template&id=20652705&scoped=true"
import script from "./EditUserModal.vue?vue&type=script&lang=js"
export * from "./EditUserModal.vue?vue&type=script&lang=js"
import style0 from "./EditUserModal.vue?vue&type=style&index=0&id=20652705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20652705",
  null
  
)

export default component.exports